import { resolvePostAuthRedirect } from './authRedirect';
import { getIntentFromSearch } from './signupIntent';
import {
  peekOAuthPostAuthRedirect,
  consumeOAuthPostAuthRedirect,
} from './oauthPostAuthRedirect';

const SIGNUP_POST_AUTH_REDIRECT_KEY = 'signupPostAuthRedirect';

export const persistSignupPostAuthRedirectPath = (path) => {
  if (path && path.startsWith('/') && !path.startsWith('//')) {
    sessionStorage.setItem(SIGNUP_POST_AUTH_REDIRECT_KEY, path);
  }
};

/**
 * Persist intended post-signup destination while the user is on an auth page.
 */
export const persistSignupPostAuthRedirect = (search) => {
  const intent = getIntentFromSearch(search);
  const explicitRedirect = new URLSearchParams(search).get('redirect');
  if (!intent && !explicitRedirect) {
    return;
  }
  persistSignupPostAuthRedirectPath(resolvePostAuthRedirect(search));
};

export const peekSignupPostAuthRedirect = () => {
  const value = sessionStorage.getItem(SIGNUP_POST_AUTH_REDIRECT_KEY);
  if (value && value.startsWith('/') && !value.startsWith('//')) {
    return value;
  }
  return null;
};

export const consumeSignupPostAuthRedirect = () => {
  const value = peekSignupPostAuthRedirect();
  sessionStorage.removeItem(SIGNUP_POST_AUTH_REDIRECT_KEY);
  return value;
};

export const clearSignupPostAuthRedirect = () => {
  sessionStorage.removeItem(SIGNUP_POST_AUTH_REDIRECT_KEY);
};

/** Read signup destination without consuming (safe before async OAuth work). */
export const peekSignupAuthDestination = () => {
  return peekOAuthPostAuthRedirect() || peekSignupPostAuthRedirect() || null;
};

/** Consume stored signup/OAuth redirect after successful auth. */
export const consumeSignupAuthDestination = () => {
  return consumeOAuthPostAuthRedirect() || consumeSignupPostAuthRedirect() || '/dashboard';
};

/**
 * Resolve post-auth path after OAuth callback (auth URL search is usually empty).
 */
export const resolveOAuthSignupDestination = () => {
  return (
    peekOAuthPostAuthRedirect()
    || peekSignupPostAuthRedirect()
    || '/dashboard'
  );
};

/**
 * Resolve post-auth path after email signup/login while still on the auth page.
 */
export const resolveEmailSignupDestination = (search, user) => {
  if (search && (getIntentFromSearch(search) || new URLSearchParams(search).get('redirect'))) {
    return resolvePostAuthRedirect(search);
  }
  const intent = getIntentFromSearch(search);
  if (intent === 'interviewer' && user && !user.is_interviewer) {
    return '/marketplace/apply';
  }
  if (intent === 'recruiter') {
    return '/hiring';
  }
  return peekSignupPostAuthRedirect() || '/dashboard';
};
